import { render, staticRenderFns } from "./WeightFee.vue?vue&type=template&id=3be3bee0&scoped=true&"
import script from "./WeightFee.vue?vue&type=script&lang=ts&"
export * from "./WeightFee.vue?vue&type=script&lang=ts&"
import style0 from "./WeightFee.vue?vue&type=style&index=0&id=3be3bee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3bee0",
  null
  
)

export default component.exports